export default {
    list: state => state.farmers,
    authStatus: state => state.status,
    
}
